// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ControlMessage, ControlMessageT, verifyControlMessage } from "../control/control-message";
import {
  ControllerInfoMessage,
  ControllerInfoMessageT,
  verifyControllerInfoMessage,
} from "../controller-info/controller-info-message";
import { FaultMessage, FaultMessageT, verifyFaultMessage } from "../fault/fault-message";
import {
  GroupControlMessage,
  GroupControlMessageT,
  verifyGroupControlMessage,
} from "../group-control/group-control-message";
import {
  GroupSupervisoryStatusMessage,
  GroupSupervisoryStatusMessageT,
  verifyGroupSupervisoryStatusMessage,
} from "../group-supervisory-status/group-supervisory-status-message";
import {
  MessageContent,
  unionToMessageContent,
  unionListToMessageContent,
} from "./message-content";
import { ServiceMessage, ServiceMessageT, verifyServiceMessage } from "../service/service-message";
import { StatusMessage, StatusMessageT, verifyStatusMessage } from "../status/status-message";
import { TrafficMessage, TrafficMessageT, verifyTrafficMessage } from "../traffic/traffic-message";
import { UsageMessage, UsageMessageT, verifyUsageMessage } from "../usage/usage-message";

export class BitMaskMessage implements flatbuffers.IUnpackableObject<BitMaskMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): BitMaskMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBitMaskMessage(bb: flatbuffers.ByteBuffer, obj?: BitMaskMessage): BitMaskMessage {
    return (obj || new BitMaskMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsBitMaskMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: BitMaskMessage,
  ): BitMaskMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new BitMaskMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  messageType(): MessageContent {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : MessageContent.NONE;
  }

  message<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startBitMaskMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMessageType(builder: flatbuffers.Builder, messageType: MessageContent) {
    builder.addFieldInt8(0, messageType, MessageContent.NONE);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }

  static endBitMaskMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // message
    return offset;
  }

  static createBitMaskMessage(
    builder: flatbuffers.Builder,
    messageType: MessageContent,
    messageOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    BitMaskMessage.startBitMaskMessage(builder);
    BitMaskMessage.addMessageType(builder, messageType);
    BitMaskMessage.addMessage(builder, messageOffset);
    return BitMaskMessage.endBitMaskMessage(builder);
  }

  unpack(): BitMaskMessageT {
    return new BitMaskMessageT(
      this.messageType(),
      (() => {
        const temp = unionToMessageContent(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: BitMaskMessageT): void {
    _o.messageType = this.messageType();
    _o.message = (() => {
      const temp = unionToMessageContent(this.messageType(), this.message.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): BitMaskMessageT {
    const t = new BitMaskMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message_type")) {
      t.messageType = this.messageType();
    }
    if (fieldSet.has("message")) {
      t.message = (() => {
        const temp = unionToMessageContent(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class BitMaskMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public messageType: MessageContent = MessageContent.NONE,
    public message:
      | ControlMessageT
      | ControllerInfoMessageT
      | FaultMessageT
      | GroupControlMessageT
      | GroupSupervisoryStatusMessageT
      | ServiceMessageT
      | StatusMessageT
      | TrafficMessageT
      | UsageMessageT
      | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const message = builder.createObjectOffset(this.message);

    return BitMaskMessage.createBitMaskMessage(builder, this.messageType, message);
  }

  clone(): BitMaskMessageT {
    const obj = new BitMaskMessageT();
    obj.messageType = this.messageType;
    obj.message =
      this.message !== null && typeof (this.message as any).clone === "function"
        ? (this.message as any).clone()
        : this.message;
    return obj;
  }

  equals(other: BitMaskMessageT): boolean {
    if (this.messageType !== other.messageType) return false;
    if (this.message !== null && other.message !== null) {
      if (typeof (this.message as any).equals === "function") {
        if (!(this.message as any).equals(other.message)) return false;
      } else if (this.message !== other.message) return false;
    } else if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyBitMaskMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "message");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // Status_StatusMessage
            {
              const o = verifier.readInt32(pos);
              verifyStatusMessage(verifier, pos + o);
            }
            break;
          case 2: // Traffic_TrafficMessage
            {
              const o = verifier.readInt32(pos);
              verifyTrafficMessage(verifier, pos + o);
            }
            break;
          case 3: // Usage_UsageMessage
            {
              const o = verifier.readInt32(pos);
              verifyUsageMessage(verifier, pos + o);
            }
            break;
          case 4: // Service_ServiceMessage
            {
              const o = verifier.readInt32(pos);
              verifyServiceMessage(verifier, pos + o);
            }
            break;
          case 5: // Control_ControlMessage
            {
              const o = verifier.readInt32(pos);
              verifyControlMessage(verifier, pos + o);
            }
            break;
          case 6: // Fault_FaultMessage
            {
              const o = verifier.readInt32(pos);
              verifyFaultMessage(verifier, pos + o);
            }
            break;
          case 7: // GroupSupervisoryStatus_GroupSupervisoryStatusMessage
            {
              const o = verifier.readInt32(pos);
              verifyGroupSupervisoryStatusMessage(verifier, pos + o);
            }
            break;
          case 8: // GroupControl_GroupControlMessage
            {
              const o = verifier.readInt32(pos);
              verifyGroupControlMessage(verifier, pos + o);
            }
            break;
          case 9: // ControllerInfo_ControllerInfoMessage
            {
              const o = verifier.readInt32(pos);
              verifyControllerInfoMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "message");
  } finally {
    verifier.popDepth();
  }
}
